import React, { useState, useEffect } from 'react';
import { func, bool } from 'prop-types';
import ModalBackground from '@alltrails/shared/components/ModalBackground';
import useMultiStepModal from '@alltrails/shared/hooks/useMultiStepModal';
import IndividualPrivacyModal from '../IndividualPrivacyModal';
import useScreenLock from '../../../../hooks/useScreenLock';
import InitialPrivacyPolicyModal from '../InitialPrivacyPolicyModal';
import PrivacyPolicyPropType from '../../../../proptypes/PrivacyPolicyPropType';
import { policyToRadioForm, PRIVACY_POLICY_KEYS_MAP } from '../../../../utils/privacy_policy_helpers';

const GeneralPrivacyPolicyModal = ({ initialPrivacyPolicy, closeModal, handleSave, loading }) => {
  const [privacyPolicy, updatePrivacyPolicy] = useState(initialPrivacyPolicy);
  const [radioModalProps, setRadioModalProps] = useState({});
  const [activeSubject, setActiveSubject] = useState('');
  const [applyBulk, toggleApplyBulk] = useState(false);
  const { mountedModal, linkedState, goBack, navigateTo, handleCloseModal, handleOnTransitionEnd } = useMultiStepModal('baseModal', closeModal);
  useScreenLock();

  useEffect(() => {
    updatePrivacyPolicy(initialPrivacyPolicy);
  }, [initialPrivacyPolicy]);

  const populateAndNavigateTo = (subject, visibility) => {
    setActiveSubject(subject);
    setRadioModalProps(policyToRadioForm(subject, visibility));
    navigateTo('radioModal');
  };

  const handleAcceptCallback = value => {
    const [outerKey, resultKey] = PRIVACY_POLICY_KEYS_MAP[activeSubject];
    // for "yes or no" radio buttons the nesting is one level up
    updatePrivacyPolicy(prevState => {
      const payload =
        resultKey === activeSubject
          ? { ...prevState[outerKey], [activeSubject]: value }
          : { ...prevState[outerKey], [activeSubject]: { ...prevState[outerKey][activeSubject], [resultKey]: value } };

      return {
        ...prevState,
        [outerKey]: payload
      };
    });
  };

  const baseModal = privacyPolicy && (
    <InitialPrivacyPolicyModal
      goBack={goBack}
      privacyPolicy={privacyPolicy}
      isMounted={linkedState.key === mountedModal}
      handleOnTransitionEnd={handleOnTransitionEnd}
      populateAndNavigateTo={populateAndNavigateTo}
      handleCloseModal={handleCloseModal}
      loading={loading}
      handleSave={handleSave}
      applyBulk={applyBulk}
      toggleApplyBulk={toggleApplyBulk}
    />
  );

  const radioModal = (
    <IndividualPrivacyModal
      goBack={goBack}
      isMounted={linkedState.key === mountedModal}
      onTransitionEnd={handleOnTransitionEnd}
      acceptCallback={handleAcceptCallback}
      {...radioModalProps}
    />
  );

  const activeModalOptions = {
    baseModal,
    radioModal
  };

  return (
    <ModalBackground closeModal={handleCloseModal} goBack={goBack}>
      {activeModalOptions[linkedState.key]}
    </ModalBackground>
  );
};

GeneralPrivacyPolicyModal.propTypes = {
  initialPrivacyPolicy: PrivacyPolicyPropType,
  closeModal: func.isRequired,
  handleSave: func.isRequired,
  loading: bool
};

GeneralPrivacyPolicyModal.defaultProps = {
  loading: false,
  initialPrivacyPolicy: null
};

export default GeneralPrivacyPolicyModal;
